<template>
    <p class="lender-info-text">
        <span
            class="lender-info-value"
            v-html="$t('ratesTable.promoDuration', { promoPercentage: promoPercentage, promoTerm: promoTerm })"
        ></span>
        <span class="lender-info-label t-small">{{ productType }}</span>
    </p>
</template>

<script setup>
import { computed } from 'vue'
import split from 'lodash/split'

const promoOfferArray = split(props.promoOffer, ';')
const promoPercentage = computed(() => promoOfferArray[0])
const promoTerm = computed(() => promoOfferArray[1])
const productType = computed(() => (props.cardType === 'Balance Transfer' ? 'On Balance Transfers' : 'On Purchases'))

const props = defineProps({
    promoOffer: {
        type: String,
        default: '0;0',
    },
    cardType: {
        type: String,
        default: 'Balance Transfer',
    },
})
</script>
